import { FunctionComponent } from "react";
import styled from "styled-components";
import { LaunchConfigurationsDTO } from "../../../../store/launch-configurations/models/dto";
import { Container } from "../components";

export interface IDefaultPageProps {
  item: LaunchConfigurationsDTO.Responses.GetSingle.T;
}

const Wrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 2fr;
  align-items: center;
  grid-row-gap: 2em;
  grid-column-gap: 2em;

  & > *:nth-child(2n+1) {
    text-align: right;
  }
`;

const DefaultPage: FunctionComponent<IDefaultPageProps> = ({ children }) => {
  return (
    <Container>
      <Wrapper>{children}</Wrapper>
    </Container>
  );
};

export default DefaultPage;
